import api from 'services/api';

const montarUrlApi = (url) => {
  if (!url) return null;

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  try {
    const apiBase = new URL(api.defaults.baseURL || '/api', window.location.origin);
    return `${apiBase.origin}${url.startsWith('/') ? url : `/${url}`}`;
  } catch (error) {
    return url;
  }
};

const normalizarFotosRanking = (data = {}) => {
  const normalizarVendedor = (vendedor) => ({
    ...vendedor,
    foto_url: montarUrlApi(vendedor?.foto_url),
  });

  return {
    ...data,
    ranking_vendedores: Array.isArray(data.ranking_vendedores)
      ? data.ranking_vendedores.map(normalizarVendedor)
      : data.ranking_vendedores,
    top3: Array.isArray(data.top3)
      ? data.top3.map(normalizarVendedor)
      : data.top3,
  };
};

class RankingComercialService {
  async buscarRankingEmpresa(companyId, filtros = {}, options = {}) {
    const params = {
      empresa: companyId,
      data_inicio: filtros.data_inicio,
      data_fim: filtros.data_fim,
    };

    if (options.force) {
      params._force = 1;
      params._t = Date.now();
    }

    const requestConfig = { params };

    if (options.force) {
      requestConfig.headers = {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      };
    }

    const response = await api.get('/n8n/comercial/ranking-vendedores-cache', requestConfig);

    if (response.data?.success && response.data?.data) {
      return {
        success: true,
        companyName: companyId,
        data: normalizarFotosRanking(response.data.data),
      };
    }

    throw new Error(response.data?.message || 'Resposta inválida da API de ranking');
  }

  /**
   * Salva a foto do vendedor e os três pontos do rosto (olhos e boca) que as cenas usam.
   *
   * `arquivo` nulo com `pontos` reposiciona o rosto sem regravar a imagem que já está no servidor.
   */
  async salvarFotoVendedor(companyId, vendedor, arquivo, pontos = null) {
    const formData = new FormData();
    formData.append('empresa', companyId);
    formData.append('vendedor_nome', vendedor.nome || vendedor.vendedor_nome || 'Vendedor não informado');
    if (arquivo) formData.append('foto', arquivo);
    if (pontos) formData.append('pontos', JSON.stringify(pontos));

    const response = await api.post(`/comercial/vendedores/${vendedor.id}/foto`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response.data?.success) {
      return response.data;
    }

    throw new Error(response.data?.message || 'Não foi possível salvar a foto do vendedor');
  }

  async removerFotoVendedor(companyId, vendedorId) {
    const response = await api.delete(`/comercial/vendedores/${vendedorId}/foto`, {
      params: {
        empresa: companyId,
      },
    });

    if (response.data?.success) {
      return response.data;
    }

    throw new Error(response.data?.message || 'Não foi possível remover a foto do vendedor');
  }
}

const rankingComercialService = new RankingComercialService();

export default rankingComercialService;
